
export const name = "embedded-viral-link-ui";
export const version = "dev";
